import { Observable, fromEvent } from 'rxjs'
import {
  share,
  map,
  repeat,
  distinctUntilChanged,
  takeUntil,
} from 'rxjs/operators'
import { areDeepEqual } from './object-util'
import { HasEventTargetAddRemove } from 'rxjs/internal/observable/fromEvent'

/**
 * Returns a stream of keys as the user presses them.
 *
 * @param eventTarget the target to subscribe to. Should be `window.document`.
 */
export function keyboardStream(
  eventTarget: HasEventTargetAddRemove<KeyboardEvent>
): Observable<KeyPress> {
  return fromEvent<KeyboardEvent>(eventTarget, 'keydown').pipe(
    // skipUntil(fromEvent(window.document, 'keyup')),
    map(
      (event): KeyPress => ({
        key: event.key,
        ctrl: event.ctrlKey,
        shift: event.shiftKey,
        alt: event.altKey,
        meta: event.metaKey,
        stopPropagation: () => event.stopPropagation(),
        preventDefault: () => event.preventDefault(),
      })
    ),
    distinctUntilChanged(areDeepEqual),
    takeUntil(fromEvent(window.document, 'keyup')),
    repeat(),
    share()
  )
}

/**
 * Key press.
 */
export interface KeyPress {
  /**
   * The textual name of the key.
   */
  key: string
  /**
   * Whether shift was held.
   */
  shift: boolean
  /**
   * Whether Ctrl was held.
   */
  ctrl: boolean
  /**
   * Whether Alt was held.
   */
  alt: boolean
  /**
   * Whether the Meta (Win, Cmd, Super) was held.
   */
  meta: boolean
  /**
   * Prevents default.
   */
  preventDefault(): void
  /**
   * Stops propagation.
   */
  stopPropagation(): void
}
